export default Object.assign({});